window.addEventListener('pplrAppInitiated', function(e) {
  const config = { attributes: true };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName == "class" && mutation.target.classList.contains('pplr_fixed')) {
        const element = document.querySelector('.pplr_h_title');

        if (element != null) {
          const productForm = document.querySelector('.product .product-form');
          const title = document.createElement('h3');
          const content = document.createElement('p');

          console.log('test', productForm, productForm.getAttribute('data-personalisation-title-string'), productForm.getAttribute('data-personalisation-content-string'));

          title.innerText = productForm.getAttribute('data-personalisation-title-string')
          content.innerText = productForm.getAttribute('data-personalisation-content-string')

          const container = document.createElement('div');
          container.classList.add('pplr_h_title');

          container.appendChild(title);
          container.appendChild(content);

          element.replaceWith(container);
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(document.body, config);
});

/*
document.addEventListener('DOMContentLoaded', function(event) {
  document.querySelectorAll('input[type="radio"].rpeck-variant-picker').forEach(function(input) {
    input.addEventListener('change', function(event) {
      var target = event.target;
      var options = '';
      var variant_select = document.querySelector('select#rpeck-product-variants');
      const select_button = input.parentNode.parentNode.querySelector('a.rpeck-variant-close');
      const add_to_cart = document.querySelector('button.product-form__submit');

      document.querySelectorAll('input[type="radio"][class="rpeck-variant-picker"]:is(:checked)').forEach(function(input, index) {
        options += '[data-option-' + (index + 1) + '="' + input.value + '"]';
      });

      if (variant_select && options && options.length > 0) {
        var selected_index = variant_select.selectedIndex;
        var matched_option = variant_select.querySelector('option' + options);

        if (matched_option) {
          variant_select.value = matched_option.value;
          variant_select.dispatchEvent(new Event('change'));

          var enabled = matched_option.getAttribute('data-available');
          enabled === "true" ? add_to_cart.removeAttribute('disabled') : add_to_cart.setAttribute('disabled', true);
          add_to_cart.querySelector('span').innerText = enabled === "true" ? 'Add To Cart' : 'Sold Out';
        }
      }

      if (select_button) select_button.classList.remove('rpeck-hidden');
    });

    input.addEventListener('change', function(event) {
      var options = {};
      document.querySelectorAll('input.rpeck-variant-picker:is(:checked)').forEach(function(input) {
        var name = input.getAttribute('name').split("—")[0].trim();
        var value = input.value;

        if (!(name in options)) options[name] = [];
        if (Array.isArray(options[name])) {
          options[name].push(value);
        } else {
          options[name] = [value];
        }

        var item = document.querySelector('.rpeck_selected_options p[data-name="' + input.getAttribute('name') + '"]');
        if (item) {
          item.querySelector('span').innerText = value;
        }
      });

      if (options) {
        var cumulative_index = 0;
        Object.entries(options).forEach(function([option, values], i) {
          var identifier = 'input[class="image_select"]';
          values.forEach(function(value, index) {
            identifier += '[data-option-' + (cumulative_index + 1) + '="' + value + '"]';
            cumulative_index++;
          });

          var item = document.querySelector(identifier);
          if (item) item.checked = true;
        });
      }
    });
  });

  document.querySelector('select#rpeck-product-variants')?.addEventListener('change', function(event) {
    var element = event.target;
    var option_index = element.options.selectedIndex;
    var option = element.options[option_index];
    var hidden_id = document.querySelector('input[name="id"][type="hidden"]');

    hidden_id.value = element.value;

    document.querySelectorAll('.price-item--regular').forEach(function(price) {
      price.innerText = option.getAttribute('data-price');
    });

    const url = new URL(location.href);
    url.searchParams.set('variant', element.value);
    history.pushState(null, '', url);
  });

  document.querySelectorAll(".rpeck-variant-close").forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      document.querySelector('#' + link.getAttribute('data-close-id')).click();
    });
  });
});

document.addEventListener('DOMContentLoaded', function(e) {
  document.querySelectorAll('summary.menu-drawer__menu-item').forEach(function(item) {
    item.addEventListener('click', function(event) {
      const element = event.currentTarget;
      const parent = element.parentNode;

      if (parent) {
        const open = parent.hasAttribute('open');
        parent.querySelectorAll('details').forEach(function(details) {
          if (open) {
            details.removeAttribute('open');
          } else {
            details.setAttribute('open', true);
          }
        });
      }
    });
  });
});
*/